import { render, staticRenderFns } from "./FactureWizard.vue?vue&type=template&id=0c9c5a80"
import script from "./FactureWizard.vue?vue&type=script&lang=js"
export * from "./FactureWizard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports